<template>
  <div class="container">
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("nominal salary") }}</label>
          <div class="control">
            <input
              class="input"
              type="text"
              v-model="editable_data.nominal_salary"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="title is-4">
          {{ format_currency(liquid_salary) }}
        </div>
        <div class="subtitle is-4">
          {{ $t("liquid salary") }}
        </div>
      </div>
      <div class="column">
        <div class="title is-4">
          {{ format_currency(liquid_minus_debt) }}
        </div>
        <div class="subtitle is-4">
          {{ $t("liquid salary minus debt") }}
        </div>
      </div>
    </div>

    <div class="columns">
      <div
        class="column"
        v-for="(active_type, aidx) in active_types"
        :style="{ backgroundColor: active_type.color }"
        :key="aidx"
      >
        <div class="title is-6 has-text-black has-text-centered">
          {{ $t(active_type.name) }}
        </div>
      </div>
    </div>
    <div class="table-container">
      <table class="table is-fullwidth is-narrow is-hoverable is-striped">
        <thead>
          <tr>
            <th></th>
            <th>{{ $t("entity") }}</th>
            <th>{{ $t("quota") }}</th>
            <th>{{ $t("original capital") }}</th>
            <th>{{ $t("term in months") }}</th>
            <th>{{ $t("annual rate") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(itm, index) in meta.tarjetas" :key="index">
            <td
              :rowspan="meta.tarjetas.length"
              class="rotate-wrapper"
              :style="{
                backgroundColor: active_types.find(
                  (at) => at.name === 'credit card'
                ).color,
              }"
              v-if="index == 0"
            >
              <!-- <div class="rotate">Tarjeta</div> -->
            </td>
            <td>
              {{ itm.entidad }}
            </td>
            <td>{{ format_currency(itm.quota) }}</td>

            <td>{{ format_currency(itm.saldo_capital) }}</td>
            <td>{{ itm.plazo || "" }}</td>
            <td>{{ itm.tasa_anual ? itm.tasa_anual * 100 + "%" : "" }}</td>
          </tr>
          <tr v-for="(itm, index) in meta.extras" :key="index">
            <td
              :rowspan="meta.extras.length"
              class="rotate-wrapper"
              v-if="index == 0"
              :style="{
                backgroundColor: active_types.find(
                  (at) => at.name === 'extrafinancing'
                ).color,
              }"
            >
              <!-- <div class="rotate">Extra</div> -->
            </td>
            <td>
              {{ itm.entidad }}
            </td>
            <td>{{ format_currency(itm.quota) }}</td>
            <td>{{ format_currency(itm.capital_original) }}</td>
            <td>{{ itm.plazo || "" }}</td>
            <td>{{ itm.tasa_anual * 100 + "%" }}</td>
          </tr>
          <tr v-for="(itm, index) in meta.hipotecas" :key="index">
            <td
              :rowspan="meta.hipotecas.length"
              class="rotate-wrapper"
              v-if="index == 0"
              :style="{
                backgroundColor: active_types.find(
                  (at) => at.name === 'mortgage'
                ).color,
              }"
            >
              <!-- <div class="rotate">Hipotecas</div> -->
            </td>
            <td>
              {{ itm.entidad }}
            </td>
            <td>{{ format_currency(itm.quota) }}</td>
            <td>{{ format_currency(itm.capital_original) }}</td>
            <td>{{ itm.plazo || "" }}</td>
            <td>{{ itm.tasa_anual ? itm.tasa_anual * 100 + "%" : "" }}</td>
          </tr>
          <tr v-for="(itm, index) in meta.prestamos" :key="index">
            <td
              :rowspan="meta.prestamos.length"
              class="rotate-wrapper"
              v-if="index == 0"
              :style="{
                backgroundColor: active_types.find((at) => at.name === 'loan')
                  .color,
              }"
            >
              <!-- <div class="rotate">Préstamo</div> -->
            </td>
            <td>
              {{ itm.entidad }}
            </td>
            <td>{{ format_currency(itm.quota) }}</td>
            <td>{{ format_currency(itm.capital_original) }}</td>
            <td>{{ itm.plazo || "" }}</td>
            <td>{{ itm.tasa_anual ? itm.tasa_anual * 100 + "%" : "" }}</td>
          </tr>
          <tr v-for="(itm, index) in meta.no_definidos" :key="index">
            <td
              :rowspan="meta.no_definidos.length"
              class="rotate-wrapper"
              v-if="index == 0"
              :style="{
                backgroundColor: active_types.find(
                  (at) => at.name === 'undefined'
                ).color,
              }"
            >
              <!-- <div class="rotate">No definido</div> -->
            </td>
            <td>{{ itm.entidad }} ({{ itm.tipo_activo }})</td>
            <td></td>
            <td>{{ format_currency(itm.capital_original) }}</td>
            <td></td>
            <td></td>
          </tr>
          <tr v-for="(itm, index) in meta.cancelados" :key="index">
            <td
              :rowspan="meta.cancelados.length"
              class="rotate-wrapper"
              v-if="index == 0"
              :style="{
                backgroundColor: active_types.find(
                  (at) => at.name === 'cancelled'
                ).color,
              }"
            >
              <!-- <div class="rotate">No definido</div> -->
            </td>
            <td>{{ itm.entidad }} ({{ itm.tipo_activo }})</td>
            <td></td>
            <td>{{ format_currency(itm.capital_original) }}</td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="title is-3 mt-6 has-text-primary">{{ $t("summary") }}</div>
    <div class="columns">
      <div class="column">
        <div class="title">{{ format_currency(total_capital) }}</div>
        <div class="subtitle">
          {{ $t("total capital") }}
        </div>
      </div>
      <div class="column">
        <div class="title">
          {{ format_currency(total_quota) }}
        </div>
        <div class="subtitle">
          {{ $t("total quota") }}
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="title is-4">{{ format_currency(total_tarjetas) }}</div>
        <div class="subtitle is-4">
          {{ $t("credit card total") }}
        </div>
      </div>
      <div class="column">
        <div class="title is-4">{{ format_currency(total_prestamos) }}</div>
        <div class="subtitle is-4">
          {{ $t("loan total") }}
        </div>
      </div>
      <div class="column">
        <div class="title is-4">{{ format_currency(total_extras) }}</div>
        <div class="subtitle is-4">
          {{ $t("extrafinancing total") }}
        </div>
      </div>
      <div class="column">
        <div class="title is-4">{{ format_currency(total_hipotecas) }}</div>
        <div class="subtitle is-4">
          {{ $t("mortgage total") }}
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="title is-4">{{ format_currency(cuota_tarjetas) }}</div>
        <div class="subtitle is-4">
          {{ $t("credit card quota") }}
        </div>
      </div>
      <div class="column">
        <div class="title is-4">{{ format_currency(cuota_prestamos) }}</div>
        <div class="subtitle is-4">
          {{ $t("loan quota") }}
        </div>
      </div>
      <div class="column">
        <div class="title is-4">{{ format_currency(cuota_extras) }}</div>
        <div class="subtitle is-4">
          {{ $t("extrafinancing quota") }}
        </div>
      </div>
      <div class="column">
        <div class="title is-4">{{ format_currency(cuota_hipotecas) }}</div>
        <div class="subtitle is-4">
          {{ $t("mortgage quota") }}
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-7">
        <div class="title is-3 mt-6 has-text-primary">
          {{ $t("debt level") }}
        </div>
        <div class="field">
          <label class="label">{{ $t("lower amount") }}</label>
          <div class="control">
            <input
              class="input"
              type="text"
              v-model="editable_data.lower_limit"
              placeholder="0.00"
            />
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("minimum quota") }}</label>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  v-model="editable_data.minimum_quota"
                  placeholder="0.00"
                />
              </div>
            </div>

            <div class="title is-5">
              <span class="mr-2">{{ $t("debt level") }}</span>
              <span
                :class="{
                  'has-text-danger': minimum_liquidity < 1000,
                  'has-text-primary': minimum_liquidity >= 1000,
                }"
                >{{ minimum_debt_level }}</span
              >
            </div>

            <div class="title is-5">
              <span class="mr-2">{{ $t("liquidity") }}</span>
              <span
                :class="{
                  'has-text-danger': minimum_liquidity < 1000,
                  'has-text-primary': minimum_liquidity >= 1000,
                }"
                >{{ format_currency(minimum_liquidity) }}</span
              >
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("maximum quota") }}</label>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  v-model="editable_data.maximum_quota"
                  placeholder="0.00"
                />
              </div>
            </div>
            <div class="title is-5">
              <span class="mr-2">{{ $t("debt level") }}</span>
              <span
                :class="{
                  'has-text-danger': maximum_liquidity < 1000,
                  'has-text-primary': maximum_liquidity >= 1000,
                }"
                >{{ maximum_debt_level }}</span
              >
            </div>
            <div class="title is-5">
              <span class="mr-2">{{ $t("liquidity") }}</span>
              <span
                :class="{
                  'has-text-danger': maximum_liquidity < 1000,
                  'has-text-primary': maximum_liquidity >= 1000,
                }"
                >{{ format_currency(maximum_liquidity) }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="title is-3 mt-6 has-text-primary">
          {{ $t("debt buying") }}
        </div>
        <div v-if="debt_buying">
          <table class="table is-fullwidth is-narrow is-hoverable is-striped">
            <thead>
              <tr>
                <th>{{ $t("credit type") }}</th>
                <th>{{ $t("bank") }}</th>
                <th>{{ $t("amount") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(itm, index) in debt_buying" :key="index">
                <td>{{ itm.credit_type }}</td>
                <td>{{ itm.bank_name }}</td>
                <td>{{ format_currency(itm.amount) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <div class="notification is-info">
            {{ $t("customer has not entered a credit list") }}
          </div>
        </div>
      </div>
    </div>

    <div class="title is-3 mt-6 has-text-primary">
      {{ $t("salaries") }}
    </div>
    <div class="columns">
      <div class="column is-4">
        <div class="field">
          <label class="label">{{ $t("inferred salary") }}</label>
          <div class="control">
            <input
              class="input"
              type="text"
              v-model="editable_data.inferred_salary"
              placeholder="0.00"
            />
          </div>
        </div>
        <div class="field">
          <label class="label">{{ $t("2025 salary") }}</label>
          <div class="control">
            <input
              class="input"
              type="text"
              v-model="editable_data.salary_2025"
              placeholder="0.00"
            />
          </div>
        </div>
        <div
          class="title is-4 mt-5"
          :class="{
            'has-text-danger':
              Number(editable_data.nominal_salary) >
              Number(editable_data.salary_2025),
          }"
        >
          {{ format_currency(editable_data.nominal_salary || 0) }}
        </div>
        <div class="subtitle is-5">
          {{ $t("customer salary") }}
        </div>
      </div>
      <div class="column">
        <div class="title is-4 is-primary">{{ salary_difference }}</div>
        <div class="subtitle is-5">
          {{ $t("difference") }}
        </div>

        <div class="title is-4 is-primary mt-5">{{ salary_percentage }}%</div>
        <div class="subtitle is-5">
          {{ $t("percentage") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  put,
  error_message,
  get,
  post,
  get_configuration,
  error_alert,
  format_currency,
  format_date_time,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import moment from "moment";
import { groupBy } from "lodash";

export default {
  name: "DebtLevelViewOriginal",
  components: {},
  data() {
    return {
      editable_data: {
        nominal_salary: "",
        lower_limit: "",
        minimum_quota: "",
        maximum_quota: "",
        inferred_salary: "",
        salary_2025: "",
      },
      meta: {},
      debt_level: {},
      debt_buying: {},
      error: "",
      module_settings: {},
    };
  },
  computed: {
    total_capital() {
      let v = this;
      let prestamos = 0;
      let tarjetas = 0;
      let extras = 0;
      let no_definidos = 0;

      if (v.meta.prestamos) {
        prestamos = v.meta.prestamos.reduce(
          (sum, item) => sum + item.capital_original,
          0
        );
      }
      if (v.meta.tarjetas) {
        tarjetas = v.meta.tarjetas.reduce(
          (sum, item) => sum + item.saldo_capital,
          0
        );
      }
      if (v.meta.extras) {
        extras = v.meta.extras.reduce(
          (sum, item) => sum + item.capital_original,
          0
        );
      }
      if (v.meta.no_definidos) {
        no_definidos = v.meta.no_definidos.reduce(
          (sum, item) => sum + item.capital_original,
          0
        );
      }

      return prestamos + tarjetas + extras + no_definidos;
    },
    total_quota() {
      let v = this;
      let prestamos = 0;
      let tarjetas = 0;
      let extras = 0;
      let no_definidos = 0;
      if (v.meta.prestamos) {
        prestamos = v.meta.prestamos.reduce((sum, item) => sum + item.quota, 0);
      }
      if (v.meta.tarjetas) {
        tarjetas = v.meta.tarjetas.reduce((sum, item) => sum + item.quota, 0);
      }
      if (v.meta.extras) {
        extras = v.meta.extras.reduce((sum, item) => sum + item.quota, 0);
      }
      // if (v.meta.no_definidos) {
      //   no_definidos = v.meta.no_definidos.reduce(
      //     (sum, item) => sum + item.quota,
      //     0
      //   );
      // }
      return prestamos + tarjetas + extras /* + no_definidos */;
    },
    liquid_salary() {
      let v = this;
      if (v.editable_data.nominal_salary)
        return v.editable_data.nominal_salary * 0.9;
      else return 0;
    },
    liquid_minus_debt() {
      let v = this;
      return v.liquid_salary - v.total_quota;
    },
    total_tarjetas() {
      let v = this;
      if (v.meta.tarjetas) {
        return v.meta.tarjetas.reduce(
          (sum, item) => sum + item.saldo_capital,
          0
        );
      } else return 0;
    },
    total_prestamos() {
      let v = this;
      if (v.meta.prestamos) {
        return v.meta.prestamos.reduce(
          (sum, item) => sum + item.capital_original,
          0
        );
      } else return 0;
    },
    total_extras() {
      let v = this;
      if (v.meta.extras) {
        return v.meta.extras.reduce(
          (sum, item) => sum + item.capital_original,
          0
        );
      } else return 0;
    },
    total_hipotecas() {
      let v = this;
      if (v.meta.hipotecas) {
        return v.meta.hipotecas.reduce(
          (sum, item) => sum + item.capital_original,
          0
        );
      } else return 0;
    },
    cuota_tarjetas() {
      let v = this;
      if (v.meta.tarjetas) {
        return v.meta.tarjetas.reduce((sum, item) => sum + item.quota, 0);
      } else return 0;
    },
    cuota_prestamos() {
      let v = this;
      if (v.meta.prestamos) {
        return v.meta.prestamos.reduce((sum, item) => sum + item.quota, 0);
      } else return 0;
    },
    cuota_extras() {
      let v = this;
      if (v.meta.extras) {
        return v.meta.extras.reduce((sum, item) => sum + item.quota, 0);
      } else return 0;
    },
    cuota_hipotecas() {
      let v = this;
      if (v.meta.hipotecas) {
        return v.meta.hipotecas.reduce((sum, item) => sum + item.quota, 0);
      } else return 0;
    },
    active_types() {
      return [
        { name: "credit card", color: "#f39c12" },
        { name: "extrafinancing", color: "#3498db" },
        { name: "mortgage", color: "#27ae60" },
        { name: "loan", color: "#e74c3c" },
        { name: "undefined", color: "#9b59b6" },
        { name: "cancelled", color: "#FFFFFF" },
      ];
    },
    minimum_debt_level() {
      let v = this;
      if (v.editable_data.minimum_quota) {
        return (
          ((v.editable_data.minimum_quota / v.liquid_minus_debt) * 100).toFixed(
            2
          ) + "%"
        );
      } else return "0%";
    },
    minimum_liquidity() {
      let v = this;
      if (v.editable_data.minimum_quota) {
        return v.liquid_minus_debt - v.editable_data.minimum_quota;
      } else return "0";
    },
    maximum_debt_level() {
      let v = this;
      if (v.editable_data.maximum_quota) {
        return (
          ((v.editable_data.maximum_quota / v.liquid_minus_debt) * 100).toFixed(
            2
          ) + "%"
        );
      } else return "0%";
    },
    maximum_liquidity() {
      let v = this;
      if (v.editable_data.maximum_quota) {
        return v.liquid_minus_debt - v.editable_data.maximum_quota;
      } else return "0";
    },
    salary_difference() {
      let v = this;
      if (
        (v.editable_data.nominal_salary && v.editable_data.salary_2025) ||
        v.editable_data.inferred_salary
      ) {
        return (
          v.editable_data.nominal_salary -
          (v.editable_data.salary_2025 || v.editable_data.inferred_salary)
        ).toFixed(2);
      } else return 0;
    },
    salary_percentage() {
      let v = this;
      if (
        v.salary_difference &&
        (v.editable_data.salary_2025 || v.editable_data.inferred_salary)
      ) {
        return (
          (v.salary_difference / v.editable_data.salary_2025 ||
            v.editable_data.inferred_salary) * 100
        ).toFixed(2);
      } else return "0.00";
    },
  },
  methods: {
    pmt(rate, nper, pv) {
      if (rate === 0) return -(pv / nper);
      const factor = Math.pow(1 + rate, nper);
      return -(pv * rate * factor) / (factor - 1);
    },
    format_currency,
    format_date_time,
    filter_data(data, conditions, type) {
      return data.filter((item) => {
        return conditions.some((condition) => {
          let valid_active_type = condition.active_type ? false : true;
          let valid_warranty = condition.warranty_type ? false : true;
          let valid_segment = condition.segment ? false : true;

          if (condition.active_type && item.tipo_activo) {
            valid_active_type =
              item.tipo_activo.toUpperCase() ===
              condition.active_type.toUpperCase();
          }

          if (condition.warranty_type && item.tipo_garantia) {
            valid_warranty =
              item.tipo_garantia.toUpperCase() ===
              condition.warranty_type.toUpperCase();
          }

          if (condition.segment && item.segmento) {
            valid_segment =
              item.segmento.toUpperCase() === condition.segment.toUpperCase();
          }

          let result = valid_active_type && valid_warranty && valid_segment;
          // if (type == "mortgage") {
          // if (result)
          //   console.log(
          //     `Result: ${result}. Item: ${item.id}, Active Type Valid: ${valid_active_type}, Warranty Valid: ${valid_warranty}, Segment Valid: ${valid_segment}`
          //   );
          // }
          return result;
        });
      });
    },
    set_module_settings(settings) {
      let v = this;
      v.module_settings = settings;
    },
    set_meta(meta) {
      let v = this;
      v.meta = meta;
    },
    set_debt_buying(debt_buying) {
      let v = this;
      v.debt_buying = debt_buying;
    },
    get_data() {
      return this.editable_data;
    },
    set_editable(data) {
      let v = this;
      v.editable_data = data;
    },
    get_meta() {
      let v = this;
      return v.meta;
    },
    get_summary() {
      let v = this;
      return {
        total_capital: v.total_capital,
        total_quota: v.total_quota,
        liquid_salary: v.liquid_salary,
        liquid_minus_debt: v.liquid_minus_debt,
        total_tarjetas: v.total_tarjetas,
        total_prestamos: v.total_prestamos,
        total_extras: v.total_extras,
        total_hipotecas: v.total_hipotecas,
        cuota_tarjetas: v.cuota_tarjetas,
        cuota_prestamos: v.cuota_prestamos,
        cuota_extras: v.cuota_extras,
        cuota_hipotecas: v.cuota_hipotecas,
      };
    },
  },
  mounted() {
    // let v = this;
    // let uuid = v.$route.params.uuid;
    // v.$root.loader(true);
    // if (uuid) {
    //   get_configuration(v)
    //     .then((settings) => {
    //       v.module_settings = settings;
    //       v.refresh();
    //     })
    //     .catch((error) => {
    //       console.error(error);
    //     })
    //     .finally(() => v.$root.loader(false));
    // } else {
    //   error_alert("No se ha proporcionado un UUID válido.");
    // }
  },
  created() {},
};
</script>

<style scoped></style>
